export default __webpack_public_path__ + "static/media/dzienDobryWarszawo.a3d8ce1e.png";